import { render, staticRenderFns } from "./AuthComponent.vue?vue&type=template&id=20d9e598&scoped=true&"
import script from "./AuthComponent.vue?vue&type=script&lang=js&"
export * from "./AuthComponent.vue?vue&type=script&lang=js&"
import style0 from "./AuthComponent.vue?vue&type=style&index=0&id=20d9e598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9e598",
  null
  
)

export default component.exports